module.exports = "<div class=\"card-hoverable\"\r\n    ng-click=\"$ctrl.seleccionar()\">\r\n  <div class=\"kd-item kd-item--small padding-md\">\r\n    <div class=\"flex nobreak\">{{::$ctrl.data.descripcion}}</div>\r\n    <div class=\"--text-small text-light\">{{::$ctrl.data.clave}}</div>\r\n  </div>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/facturacion/configuracion/components/conceptos/editar/unidadesmedida/item/template.html
// module id = 2661
// module chunks = 0